import { Business as BusinessIcon } from "@mui/icons-material";
import { Avatar, Button, CircularProgress, Grid, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { RenderStates, type RenderStatesProps } from "~ui/atoms/RenderStates/RenderStates";

export interface District {
  id: string;
  name: string;
  avatarUri?: string;
}

export type DistrictsTemplateBaseProps = Pick<RenderStatesProps<District[]>, "data" | "status">;

export type DistrictsTemplateProps = DistrictsTemplateBaseProps;

export const DistrictsTemplate = ({ data, status }: DistrictsTemplateProps) => {
  return (
    <RenderStates
      data={data}
      status={status}
      empty={<Typography>No districts found</Typography>}
      error={<Typography color="error">Error loading districts</Typography>}
      pending={<CircularProgress />}
      success={(districts) => (
        <Grid container spacing={2}>
          {districts.map((district) => (
            <Grid key={district.id} size={12}>
              <Button
                component={RouterLink}
                sx={{
                  borderRadius: "4px",
                  color: "inherit",
                  justifyContent: "flex-start",
                  padding: {
                    md: "1rem",
                    sm: "0.75rem",
                    xs: "0.5rem",
                  },
                  textAlign: "left",
                  textTransform: "none",
                  width: "100%",
                }}
                to={`/admin?schoolAndDistrictSelect=${district.id}`}
                variant="text"
              >
                <Grid alignItems="center" container direction="row" gap={{ md: "2.5rem", sm: "1.5rem", xs: "1rem" }}>
                  <Grid container direction="row" size="grow">
                    <Grid>
                      <Avatar
                        slotProps={{
                          img: {
                            "aria-label": `${district.name} district avatar`,
                          },
                        }}
                        src={district.avatarUri}
                        sx={{
                          height: { md: "3.5rem", sm: "3rem", xs: "2.5rem" },
                          width: { md: "3.5rem", sm: "3rem", xs: "2.5rem" },
                        }}
                      >
                        <BusinessIcon />
                      </Avatar>
                    </Grid>
                    <Grid marginLeft={{ md: "1em", sm: "0.75em", xs: "0.5em" }}>
                      <Typography
                        component="p"
                        sx={{
                          fontSize: { md: "1.25rem", sm: "1rem", xs: "0.9rem" },
                        }}
                        variant="h6"
                      >
                        {district.name}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Button>
            </Grid>
          ))}
        </Grid>
      )}
    />
  );
};
